/* eslint-disable */
export function isoDateSubtract(initial, daysToSubtract) {
  const date = new Date(initial);
  date.setDate(date.getDate() - daysToSubtract);
  return date.toISOString().substring(0, 10);
}
